import { IAssetResponse } from '@kcftech/prometheus-client';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQuery,
    DataSourceSort,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    InfiniteDataSource,
    useInfiniteDataSource,
} from 'custom_hooks/data_hooks/data_source/useInfiniteDataSource';
import { buildOrderBy, Filter, toDataSourceResult } from 'utils/query_v3';

const defaultSort: DataSourceSort[] = [{ field: 'Name', dir: 'asc' }];

export type AssetFilter = Readonly<{
    includeAnalyticsModels?: boolean;
    corporationId?: string;
    locationId?: string;
    groupIds?: string[];
    excludeGroupIds?: string[];
    nameSearch?: string;
}>;

export type AssetDataSourceOptions = BaseDataSourceOptions<IAssetResponse, AssetFilter>;

const queryFn: DataSourceQuery<IAssetResponse, AssetFilter> = ({
    filter: { includeAnalyticsModels, locationId, corporationId, groupIds, nameSearch },
    sort,
    page,
    pageLimit,
}) => {
    const filter = Filter.and(
        corporationId ? Filter.eq('CorporationId', corporationId) : undefined,
        locationId ? Filter.eq('LocationId', locationId) : undefined,
    );

    const orderBy = buildOrderBy(sort);

    return toDataSourceResult(
        sdClient.getAssets({
            groupIds,
            includeAnalyticsModels,
            filter,
            page,
            pageLimit,
            orderBy,
            nameSearch,
        }),
    );
};

export type AssetInfiniteDataSource = InfiniteDataSource<IAssetResponse, AssetFilter>;

export function useInfiniteAssetDataSource(
    options: AssetDataSourceOptions,
): AssetInfiniteDataSource {
    return useInfiniteDataSource({
        defaultSort,
        ...options,
        query: queryFn,
    });
}
